import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Validation utilities
export function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return url.startsWith('http://') || url.startsWith('https://');
  } catch {
    return false;
  }
}

// File utilities
export function sanitizeFileName(name: string): string {
  return name.replace(/[^a-zA-Z0-9-_.]/g, '');
}

export function generateFileName(definitionName: string): string {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `${definitionName}-${timestamp}.yaml`;
}

// Form utilities
export function getDefaultResearchDefinition(): import('../types/research-definition').ResearchDefinitionData {
  return {
    name: '',
    title: '',
    task: '',
    description: '',
    urls: [],
    target_word_count: 2000,
    metadata: {
      research_date: new Date().toISOString().split('T')[0],
      version: '1.0',
      tags: []
    }
  };
}

// Array utilities
export function removeArrayItem<T>(array: T[], index: number): T[] {
  return [...array.slice(0, index), ...array.slice(index + 1)];
}

export function updateArrayItem<T>(array: T[], index: number, item: T): T[] {
  return [...array.slice(0, index), item, ...array.slice(index + 1)];
}

// String utilities
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .substring(0, 50);
}

// Date utilities
export function formatDate(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString();
}

// Error utilities
export function createErrorMessage(error: any): string {
  if (typeof error === 'string') return error;
  if (error?.message) return error.message;
  return 'An unknown error occurred';
}
